import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { MediaService } from '../../../services/MediaService';

interface State {
}

interface Props {
    media: ReqType.Media;
}

/**
 * ce composant permet l'affichage d'un Media dans une card
 */
export class MediaCard extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div
                className="card card-default"
            >
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong>{this.props.media.nom}</strong>
                    </h4>
                </div>

                <div className="card-body text-center HeaderElement">
                    {this.getMediaDisplayer()}
                </div>

                <div className="card-footer">
                    {this.props.media.description}
                </div>
            </div>
        );
    }

    private getMediaDisplayer() {
        if (this.props.media.type_media_id === ReqType.Type_Media.VIDEO) {
            return (
                <video controls={true} className="col-8">
                    <source
                        src={
                            MediaService.getInstance().getBaseURL() +
                            this.props.media.lien
                        }
                        type="video/mp4"
                    />
                </video>
            );
        } else {
            return (
                <img
                    className="col-8"
                    src={
                        MediaService.getInstance().getBaseURL() +
                        this.props.media.lien
                    }
                />
            );
        }
    }
} 


// WEBPACK FOOTER //
// ./src/components/MediasPage/internalComponents/MediaCard.tsx